import React, { useEffect, useRef, useState } from "react";
import titleimg from "../../../../assets/images/worldbook/left-dedication.png";
import ReactQuill from "../../../../app-services/lib/ReactQuill";

const Dedication = (props) => {
  const {
    formdata,
    setFormdata,
    handlePreinfoSave = () => {},
    handlebackbtn = () => {},
  } = props;
  const [alert, setAlert] = useState(null);
  const [limit, setLimit] = useState(450);
  const [widthdata, setWidthdata] = useState(0);
  const nameRef = useRef();
  const handleChange = (val) => {
    setFormdata(val);
  };
  const handlesubmit = (e) => {
    e.preventDefault();
    handlePreinfoSave();
  };
  useEffect(() => {
    if (alert) {
      setTimeout(() => {
        setAlert(null);
      }, 2000);
    }
  }, [alert]);
  useEffect(() => {
    if (formdata?.dedication) {
      let count = stripHtmlAndCountText(formdata?.dedication);
      setLimit(450 - count);
    } else {
      setLimit(450);
    }
  }, [formdata]);

  const stripHtmlAndCountText = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const textNodes = Array.from(tempDiv.childNodes)
      .filter(
        (node) =>
          node.nodeType === Node.TEXT_NODE ||
          (node.nodeType === Node.ELEMENT_NODE && node.tagName !== "BR")
      )
      .map((node) => node.textContent.trim())
      .filter((text) => text.length > 0);
    return textNodes.join(" ").length;
  };

  const handleEditData = (event) => {
    const imgWidth = event.target.width;
    console.log("Width", event.target.width);
    const scaleFactor = 0.025;
    if (imgWidth) {
      setWidthdata(imgWidth * 0.6);
      document.querySelectorAll(".dedication-content p").forEach((el) => {
        el.style.setProperty(
          "font-size",
          `${imgWidth * scaleFactor}px`,
          "important"
        );
      });
    }
  };

  const cleanHeadingsToP = (content) => {
    for (let i = 1; i <= 6; i++) {
      content = content.replace(new RegExp(`<h${i}[^>]*>`, "g"), "<p>");
      content = content.replace(new RegExp(`</h${i}>`, "g"), "</p>");
    }
    content = content.replace(/\s*(id|class)="[^"]*"/g, "");
    content = content.replace(/<p>\s*<\/p>/g, "");
    content = content.replace(/\n\s*\n/g, "\n");
    return content.trim();
  };

  // Pasted content (Word, Google Docs, other sites, etc.) keeps its source's
  // inline style="" attributes (color, background, font, ...) through
  // Quill's paste handling here since only matchVisual is disabled. Those
  // styles fight with the frame's own font/centering, and a run of pasted
  // text that arrives as one long unbroken <p> can overflow the fixed-size
  // frame instead of wrapping. Strip every inline style attribute so the
  // preview always renders using the frame's own CSS, regardless of source.
  const stripInlineStyles = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    tempDiv.querySelectorAll("[style]").forEach((el) => {
      el.removeAttribute("style");
    });
    return tempDiv.innerHTML;
  };

  // Same paste sources also bring their own semantic/formatting tags
  // (em, strong, pre, span, ...) that this editor's toolbar is disabled and
  // never produces itself. Unwrap them (keep the text, drop the tag) so the
  // frame's own font/weight/spacing always wins instead of whatever the
  // source page used.
  const SPECIAL_TAGS = [
    "em", "i", "strong", "b", "u", "s", "strike", "sub", "sup",
    "mark", "small", "pre", "code", "font", "blockquote", "q",
    "abbr", "cite", "kbd", "samp", "var", "ins", "del", "span",
  ];
  const stripFormattingTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    tempDiv.querySelectorAll(SPECIAL_TAGS.join(",")).forEach((el) => {
      const parent = el.parentNode;
      while (el.firstChild) {
        parent.insertBefore(el.firstChild, el);
      }
      parent.removeChild(el);
    });
    return tempDiv.innerHTML;
  };

  // Quill represents a plain space as a non-breaking space in a lot of
  // places (e.g. at the start/end of a line, to stop the browser collapsing
  // it) — swap every one of those back to a regular space before this is
  // ever persisted or shown elsewhere.
  const NBSP_CHAR = String.fromCharCode(160);
  const replaceNbspWithSpace = (html) =>
    html
      .replace(/&nbsp;/gi, " ")
      .split(NBSP_CHAR)
      .join(" ");

  // None of the three sanitizers above can run on every keystroke: each
  // does html -> tempDiv.innerHTML -> html (or, for replaceNbspWithSpace,
  // swaps which whitespace character is stored), so the string handed to
  // handleChange can come out different from the exact string Quill itself
  // just produced — even a single trailing/leading space swapped for its
  // non-breaking form (or back) is enough. Feeding that back into the
  // controlled `value` prop makes Quill re-render and reconcile against a
  // value that no longer matches what's actually in the editor, and
  // depending on where that mismatch lands, the character right at that
  // position can silently fail to appear until the *next* keystroke — i.e.
  // it looks like every space needs to be typed twice. Run this combined
  // pass only on blur, once the user is done typing in this field — see
  // onChange/onBlur below.
  const sanitizeDedicationHtml = (html) => {
    let cleaned = cleanHeadingsToP(html);
    cleaned = stripInlineStyles(cleaned);
    cleaned = stripFormattingTags(cleaned);
    cleaned = replaceNbspWithSpace(cleaned);
    return cleaned;
  };

  return (
    <div id="msform">
      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="picture ">
                <div className="dedication-container">
                  <img
                    src={titleimg}
                    alt=""
                    onLoad={(event) => {
                      handleEditData(event);
                    }}
                  />
                  <div
                    className="dedciation-top"
                    style={{
                      width: `${widthdata}px`,
                      margin: "auto",
                      maxHeight: `${widthdata}px`,
                    }}
                  >
                    <div
                      className="dedication-content"
                      dangerouslySetInnerHTML={{ __html: formdata?.dedication }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="rt-content">
                <h4>
                  More space for a special message or leave it blank for
                  autographs
                </h4>
                <ReactQuill
                  theme="snow"
                  value={formdata?.dedication || ""}
                  onChange={(content) => {
                    // Kept as close to a pure passthrough of Quill's own
                    // content as possible — see sanitizeDedicationHtml
                    // above for why running the html-round-trip sanitizers
                    // here breaks typing a space. preventEmojicontent is a
                    // plain string regex with no DOM round-trip, so it's
                    // safe to keep live.
                    let new_content = mixins.preventEmojicontent(content);
                    if (new_content === (formdata?.dedication || "")) {
                      return;
                    }
                    let count = stripHtmlAndCountText(new_content);
                    if (count <= 450) {
                      handleChange({ ...formdata, dedication: new_content });
                    } else {
                      handleChange({ ...formdata });
                    }
                  }}
                  onBlur={() => {
                    let current = formdata?.dedication || "";
                    let cleaned = sanitizeDedicationHtml(current);
                    if (cleaned !== current) {
                      handleChange({ ...formdata, dedication: cleaned });
                    }
                  }}
                  placeholder="A special message"
                  modules={{
                    toolbar: false, // Disable the toolbar
                    clipboard: {
                      matchVisual: false, // Optional: prevent visual formatting
                    },
                  }}
                  className="editor"
                />
                <span className="limit">{limit}</span>
                {alert && (
                  <span
                    style={{
                      color: "red",
                    }}
                  >
                    {alert}
                  </span>
                )}

                <div className="save-btn">
                  <button
                    style={{
                      display: "none",
                    }}
                    id="action-btn"
                    className="action-button"
                    onClick={handlesubmit}
                  >
                    Save & Back to List
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(Dedication);
